import {OrganizationAddress} from '../organization/organization-address';
import {ValidatedAddressInfo} from '../model/validated-address-info';

export class AddressUtils {

  static GENERAL_DELIVERY = 'GENERAL DELIVERY';

  public static validatedAddressIsDifferent(validated: ValidatedAddressInfo[], address: OrganizationAddress): boolean {
    if (!validated || validated.length === 0) {
      return false;
    }
    const target: ValidatedAddressInfo = validated[0];
    return this.isTextDifferent(target.line1, address.addressLine1)
      || this.isTextDifferent(target.line2, address.addressLine2)
      || this.isTextDifferent(target.line3, address.addressLine3)
      || this.isTextDifferent(target.postalCode, address.postalCode)
      || this.isTextDifferent(target.city, address.cityName);
  }

  private static isTextDifferent(line1: string, line2: string): boolean {
    if (!line1 || line1.trim().length === 0) {
      return !!(line2 && line2.trim().length > 0);
    }
    if (!line2 || line2.trim().length === 0) {
      return true;
    }
    return line1.trim().toUpperCase() !== line2.trim().toUpperCase();
  }

  public static isGeneralDeliverySpecified(address: OrganizationAddress): boolean {
    return address && (AddressUtils.containsGeneralDelivery(address.addressLine1) ||
      AddressUtils.containsGeneralDelivery(address.addressLine2) ||
      AddressUtils.containsGeneralDelivery(address.addressLine3));
  }

  public static containsGeneralDelivery(address: string): boolean {
    return !!(address && address.toUpperCase().indexOf(this.GENERAL_DELIVERY) >= 0);
  }

  public static injectGeneralDeliveryLine(address: OrganizationAddress): ValidatedAddressInfo | undefined {
    if (!this.isEmpty(address.addressLine1) && !this.isEmpty(address.addressLine2) && !this.isEmpty(address.addressLine3)) {
      return undefined;
    }
    const validatedAddress = this.convertAddress(address);
    if (this.isEmpty(address.addressLine1)) {
      validatedAddress.line1 = this.GENERAL_DELIVERY;
    } else if (this.isEmpty(address.addressLine2)) {
      validatedAddress.line2 = this.GENERAL_DELIVERY;
    } else {
      validatedAddress.line3 = this.GENERAL_DELIVERY;
    }
    return validatedAddress;
  }

  public static updateAddressWithValidated(address: OrganizationAddress, validated: ValidatedAddressInfo): OrganizationAddress {
    address.addressLine1 = validated.line1;
    address.addressLine2 = validated.line2;
    address.addressLine3 = validated.line3;
    address.cityName = validated.city;
    address.stateCode = validated.region;
    address.postalCode = validated.postalCode;
    return address;
  }

  private static convertAddress(address: OrganizationAddress): ValidatedAddressInfo {
    const result = new ValidatedAddressInfo();
    result.line1 = address.addressLine1;
    result.line2 = address.addressLine2;
    result.line3 = address.addressLine3;
    result.city = address.cityName;
    result.region = address.stateCode;
    result.postalCode = address.postalCode;
    result.country = address.countryCode;
    return result;
  }

  private static isEmpty(addressLine: string): boolean {
    return !addressLine || addressLine.trim() === '';
  }

}
